import React, { useState, useContext, createContext } from 'react'
import Queue from '../utils/queue'
import { PapiroConsole } from '../utils/papiroConsole'

export const LastCalledsQueueContext = createContext()

export const LastCalledsQueueProvider = ({ children }) => {
  
  const [lastCalleds, setLastCalleds] = useState(new Queue())

  const instantiateCalledsQueue = _ => {
    setLastCalleds(new Queue())
  }

  const equeuelastCalledsQueue = (element) => {
    PapiroConsole.log("=== equeuelastCalledsQueue -> context ===")
    PapiroConsole.log(element)
    if (lastCalleds.size() === 10)
      lastCalleds.dequeue()
    lastCalleds.equeue(element)
  }

  const clearlastCalledsQueue = _ => {
    lastCalleds.clear()
  }
  
  return (
    <LastCalledsQueueContext.Provider value={{ lastCalledsQueue: lastCalleds, instantiateCalledsQueue, equeuelastCalledsQueue, clearlastCalledsQueue }}>
      {children}
    </LastCalledsQueueContext.Provider>
  )
}

export function useLastCalledsQueueContext() {
  const context = useContext(LastCalledsQueueContext)

  return context
}